import {
  IsEmail,
  IsNotEmpty
} from 'class-validator';

import { t } from '@app-velocity/i18n';

export class UserEditEmailDto {
  @IsNotEmpty({
    message: t('users:validation.email_cannot_be_empty'),
  })
  @IsEmail(
    {},
    {
      message: t('users:validation.email_is_not_valid'),
    }
  )
  email = '';

  @IsNotEmpty({
    message: t('users:validation.email_cannot_be_empty'),
  })
  password = '';
}
